<template>
    <div>
      <nav class="navbar navbar-dark navbar-expand-xl">
        <a href="/" class="ms-4 navbar-brand">
          <img src="/vangemert.dev_200.png"
               alt="Logo"
               width="40"
               height="40"
               >
          vangemert.dev
        </a>
        <button class="navbar-toggler mx-4"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarcollapseid">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse mx-3"
             id="navbarcollapseid">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <RouterLink to="/"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                HOME
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/blog"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                BLOG
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/side-projects"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                SIDE PROJECTS
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/about"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                ABOUT
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/contact"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                CONTACT
              </RouterLink>
            </li>
            <li class="nav-item"
                v-if="logged_in">
              <button type="button"
                      class="mx-1 nav-link w-100"
                      @click="sign_out">
                SIGN OUT
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </div>
</template>
<script>
  import { Hub } from 'aws-amplify/utils'
  import { signOut, fetchAuthSession } from 'aws-amplify/auth'

  export default {
    name: 'NavBar',
    data() {
      return {
        logged_in: false
      }
    },
    methods: {
      sign_out: async function() {
        console.debug('Signing out')
        await signOut()
        this.check_logged_in()
      },
      check_logged_in: function() {
        fetchAuthSession().then(session => {
          if (!session.tokens) {
            console.debug('NavBar determined you are not logged in')
            this.logged_in = false
            return
          }
          console.debug('NavBar determined you are logged in')
          this.logged_in = true
        })
      }
    },
    mounted() {
      this.check_logged_in()

      Hub.listen('auth', ({ payload }) => {
        switch (payload.event) {
          case 'signedIn':
            this.check_logged_in()
        }
      })
    }
  }

</script>
<style scoped>
.navbar-brand {
  font-family: "Courier New", Courier, monospace;
}

nav {
  background: linear-gradient(90deg, rgb(0, 0, 0) 0%, rgb(43, 43, 43) 100%) !important;
}

.nav-link {
  font-family: "Open Sans", sans-serif;
  font-size: 22px;
  font-weight: bold;
}

.router-link-exact-active {
  color: #eee !important
}
</style>

